// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const { HireCardImageSelector } = require('components/hire/hireCardImageSelector/hireCardImageSelector');
const HireCardNameSelector = require('components/hire/hireCardNameSelector/hireCardNameSelector');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

// @constants
const {
    CREDIT_CARD_REVOLVING_PROCESS,
    OPEN_CREDIT_CARD_AQUAMARINE_CARDART,
} = require('constants/flagBasedFeatures');

class HireCardOpenCreditStep2 extends React.Component {

    getCardImagesIds() { 
        const cardImageIds = [
            'B.500.801.028',
        ];

        return cardImageIds;
    }

    render() {
        const {
            extraImage,
            immFlagBasedFeatures,
            immHireCardImageSelector,
            immHireCardNameSelector,
        } = this.props;
        const cardImageIds = this.getCardImagesIds();

        const disclaimerPersonalInfoUrl = formatText('disclaimerPersonalInfo-visaOpenLinkUrl');
        const messageContainerClasses = classNames('hire-card-open-credit__message-container', {
            'hire-card-open-credit__message-container--border-top': immHireCardNameSelector.get('names').size === 1,
            'hire-card-open-credit__message-container--hidden': !immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS)
        });

        return (
            <article className="hire-card-open-credit__step-two">
                <FormattedText
                    className="hire-card-open-credit__step-title"
                    value="hireCardOpenCredit-step2Title"
                />
                <HireCardImageSelector
                    cardImageIds={cardImageIds}
                    extraClass="hire-card-open-credit__card-image-selector"
                    extraImage={extraImage}
                    immHireCardImageSelector={immHireCardImageSelector}
                />
                <HireCardNameSelector
                    borderTop={true}
                    immHireCardNameSelector={immHireCardNameSelector}
                />
                <div className={messageContainerClasses}>
                    <OKMessage type="informative">
                        <FormattedText value="disclaimerPersonalInfo-visaOpenMsg" />
                        &nbsp;
                        <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                            <FormattedText value="disclaimerPersonalInfo-visaOpenLinkText" />
                        </OKLink>
                    </OKMessage>
                </div>
            </article>
        );
    }
}

HireCardOpenCreditStep2.propTypes = {
    extraImage: PropTypes.string,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
};

module.exports = HireCardOpenCreditStep2;
